// Service menu and vehicle type definitions.
// SERVICES is intentionally an empty fallback — DynamoDB SERVICES_TABLE is the source of truth.
// VEHICLE_TYPES + VEHICLE_LABELS are static (compile-time) and shared across UI + tests.

// `category` 필드: 'auto' (10종) / 'motorcycle' (5종, 배기량 분류)
// `icon` 필드는 lucide-react 아이콘명. Sedan→Car, SUV→Caravan, van/truck→Van, two-wheeler→Motorbike.
export const VEHICLE_TYPES = [
  { id: 'compact',       name: '경차',                  example: '모닝, 스파크',          icon: 'Car',       category: 'auto' },
  { id: 'compact-suv',   name: '준중형·경SUV',          example: '아반떼, 베뉴',          icon: 'Car',       category: 'auto' },
  { id: 'mid-sedan',     name: '중형 세단·소형 SUV',    example: '쏘나타, 코나',          icon: 'Car',       category: 'auto' },
  { id: 'premium-sedan', name: '준대형 세단·스포츠',    example: 'K8, 스팅어',            icon: 'Car',       category: 'auto' },
  { id: 'large-sedan',   name: '대형 세단·준중형 SUV',  example: '그랜저, 투싼',          icon: 'Car',       category: 'auto' },
  { id: 'mid-suv',       name: '중형 SUV',              example: '싼타페, 쏘렌토',        icon: 'Caravan',   category: 'auto' },
  { id: 'premium-suv',   name: '준대형 SUV',            example: '팰리세이드',            icon: 'Caravan',   category: 'auto' },
  { id: 'large-suv',     name: '대형 SUV',              example: 'GV80, X7',              icon: 'Caravan',   category: 'auto' },
  { id: 'van',           name: '승합·RV·밴·1톤',        example: '카니발, 스타리아, 봉고, 포터', icon: 'Van', category: 'auto' },
  { id: 'motorcycle-125',       name: '125cc 미만',     example: '스쿠터, 배달바이크',    icon: 'Motorbike', category: 'motorcycle' },
  { id: 'motorcycle-quarter',   name: '쿼터급',         example: '126~250cc',             icon: 'Motorbike', category: 'motorcycle' },
  { id: 'motorcycle-middle',    name: '미들급',         example: '251~600cc',             icon: 'Motorbike', category: 'motorcycle' },
  { id: 'motorcycle-liter',     name: '리터급',         example: '601~1000cc',            icon: 'Motorbike', category: 'motorcycle' },
  { id: 'motorcycle-overliter', name: '오버리터급',     example: '1000cc 초과',           icon: 'Motorbike', category: 'motorcycle' },
];

// 카테고리별 헬퍼 — UI에서 자동차 표 / 오토바이 표 분리에 사용.
export const AUTO_VEHICLE_TYPES = VEHICLE_TYPES.filter(v => v.category === 'auto');
export const MOTORCYCLE_VEHICLE_TYPES = VEHICLE_TYPES.filter(v => v.category === 'motorcycle');

export const VEHICLE_LABELS = Object.fromEntries(
  VEHICLE_TYPES.map(v => [v.id, v.name])
);

export const SERVICES = [];

// 손님 노출에서 숨길 서비스 — DB·관리자 화면에는 보존, 일반 손님 화면에서만 가림.
// 현재는 비어있음 (2026-05-12: interior-care + 그래핀 row 자체를 DDB에서 삭제).
export const HIDDEN_SERVICE_IDS = [];

// Booking step 1 — 자동차 차종일 때 노출되는 6개 서비스 (대표 확정 공식 가격표 기준, 2026-05-12).
// 순서: 가격 낮은 메뉴 → 높은 메뉴.
export const VISIBLE_SERVICE_IDS = [
  'exterior-only',
  'interior-only',
  'premium-wash',
  'premium-polish',
  'hydro-coating',
  'glass-coating-ceramic',
];

// Booking step 1 — 오토바이는 외부세차 1종만 (다른 메뉴는 차종별 상의).
export const MOTORCYCLE_VISIBLE_SERVICE_IDS = [
  'basic-wash',
];

// Customer-facing short labels (override DB `name` for cleaner UX in booking step 1).
// 대표 확정 공식 가격표(2026-05-12) 라벨과 통일.
export const SERVICE_DISPLAY_NAMES = {
  'exterior-only': '외부 세차',
  'interior-only': '내부 세차',
  'premium-wash': '내+외 세차',
  'premium-polish': '광택',
  'hydro-coating': '유막·발수 코팅',
  'glass-coating-ceramic': '유리막 코팅',
  'basic-wash': '오토바이 외부세차',
};

// Package definitions — when the package is chosen, the included items are auto-removed
// from selection and visually disabled to prevent double-pay.
export const PACKAGE_INCLUDES = {
  'premium-wash': ['exterior-only', 'interior-only'],
};

// Services that occupy the rest of the day → bookable only in the last slot (booking step 3).
export const LAST_SLOT_ONLY_SERVICE_IDS = ['glass-coating-ceramic'];

// 오토바이 전용 카피 — 자동차용 description이 부적절한 케이스.
// 현재는 basic-wash 1종만 노출이므로 한 줄 안내.
export const MOTORCYCLE_SERVICE_LABELS = {
  'basic-wash': {
    name: '오토바이 외부세차',
    desc: '고온 스팀 외부 세척 (5만원). 광택·디테일링 등 추가 작업은 차종별 상의.',
  },
};
